module.exports = {
      id: "tv-usage",
      viewBox: "0 0 24.014 24",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#tv",
      toString: function () {
        return this.url;
      }
    }